import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sticker-icon',
  templateUrl: './sticker-icon.component.html',
  styleUrls: ['./sticker-icon.component.scss'],
})
/**
 * Atom that shows a icon followed by a text in something like a sticker
 */
export class StickerIconComponent {
  @Input() icon?: string;
  private _small: boolean = false;

  /**
   * Decides if the component size is small
   * @return {boolean}
   */
  @Input()
  get small(): boolean {
    return this._small;
  }

  /**
   * Sets this component size as small by using an html attribute
   * @param {any} value
   */
  set small(value: any) {
    this._small = coerceBooleanProperty(value);
  }
}
